import { init } from '../hooks/useShuttleState';
export const lazyLoad = (state, action) => {
    if (action.type === 'LAZY_LOAD') {
        return init(action.data);
    }
    return { ...state };
};
